module.exports = __webpack_public_path__ + "static/media/JH_web_4.288396ed.jpg";